/* import __COLOCATED_TEMPLATE__ from './ac-tab.hbs'; */
import Component from '@ember/component';
import { service } from '@ember/service';
import { computed } from '@ember/object';
import PrettyNum from '../utils/pretty-num-wrapper';

export default class AcTab extends Component {
    tagName = '';

    @service intl;
    @service('data') model;
    @service selectionData;

    acInputSignalBodyArgs = {};

    init() {
        super.init();

        this.acInputSignalBodyArgs = {
            analogFrontEndDesignArticleLink: this.intl.t('urls.articles.frontEndDesign'),
        };
    }

    @computed(
        'selectionData.selectedAdc.partCore',
        'model.inputSettlingArrays.inputFrequencyWhereSlewDominatesKickback',
    )
    get acKickbackWarningArgs() {
        return {
            adc: this.selectionData.selectedAdc.partCore,
            frequencyCutoff: PrettyNum.eng3(this.model.inputSettlingArrays.inputFrequencyWhereSlewDominatesKickback),
        };
    }
}
